import { Badge } from '@/shared/components/ui/badge'
import { cn } from '@/shared/lib/utils'

import { LEAD_SOURCES } from '../../constants/leads'
import { SOURCE_STYLES } from '../../constants/sourceStyles'

export function SourceBadge({ source }) {
  const config = SOURCE_STYLES[source] || SOURCE_STYLES[LEAD_SOURCES.OFFLINE]
  const Icon = config.icon

  return (
    <Badge
      className={cn(
        'gap-1.5 rounded-full border px-2.5 py-1 text-[11px] font-semibold',
        config.className,
      )}
    >
      {Icon ? <Icon className="size-3" /> : null}
      {config.label}
    </Badge>
  )
}
